import { useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export const DynamicInputField = ({ label, type, name, value, onChange, isDropdown = false, options = [], showPassMsg, error, constant_label, showPass, password_policy }) => {
  const [showPassword, setShowPassword] = useState(true);
  return (
    <FormGroup>
      <Label for={name}>{label}</Label>
      {isDropdown ? (
        <Input type="select" name={name} id={name} value={value} onChange={onChange} className={error ? "is-invalid" : ""}>
          {/* Options render kar rahe hain */}
          <option value="">Select role</option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </Input>
      ) : (
        <>
        <div style={{position:'relative'}}>
        <Input  type={showPass && showPassword ? "password" : "text"} name={name} id={name} value={value} onChange={onChange} className={error ? "is-invalid" : ""} />
          {showPass && (
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "8%",
                  transform: "translateY(-50%)",
                  cursor: "pointer"
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            )}
        {
          constant_label && (
            
            <div style={{color:'red'}}>{constant_label}</div>
          )
        }
        {
          password_policy && (
            <>
            <div style={{color:'red'}}>
              <p className="p-0 m-0">Password Policy</p>
              <p className="p-0 m-0">· a minimum of 14 characters long </p>
              <p className="p-0 m-0">· a combination of three random words which are unrelated and not connected to your personal information </p>

            </div>
            <div className="border rounded-3 mt-3 p-3" style={{backgroundColor:'#c9c7c7', borderColor:'#b3b3b3'}}>
              <p className="p-0 m-0">Few things to remember</p>
              <p className="p-0 m-0">· Don’t share your password with anyone </p>
              <p className="p-0 m-0">· Don’t write your password down </p>
              <p className="p-0 m-0">·  Always use different passwords for different accounts </p>
              <p className="p-0 m-0">·  Don’t use things which are easy to guess – e.g., sports teams, family or pet names, Unilever brands </p>
            
            </div>
            </>
          )
        }

        </div>
       
      </>
      )}
      {error && <div className="invalid-feedback">{error}</div>}
      {/* {showPassMsg && <p className="text-muted mt-2 small text-center">Password must be at least 8 characters long including one uppercase letter, one lowercase letter, one number, and one special character. </p>} */}
    </FormGroup>
  );
};
